import { useState } from 'react';
import { v1 as uuidv1 } from 'uuid';
import ErrorIcon from '@mui/icons-material/Error';
import HelpIcon from '@mui/icons-material/Help';
import {
  Button,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import HoverTooltip from './HoverTooltip';
import './TooltipWithIndicator.scss';
import CustomTooltip from '../card/CustomTooltip';
import { filterUndefined } from '../../utils/FilterUndefinedObject';

/**
 * Tooltip dialog component.
 * Dialogs inform users about a task and can contain critical information, require decisions
 */
const defaultProps = {
  title: 'title',
  messages: ['text line 1', 'text line 2', 'text line 3'],
  className: '',
  videoUrl: '',
  dialogClassName: '',
  isHoverable: false,
};
export default function TooltipWithIndicator(props) {
  const {
    className,
    title,
    messages,
    videoUrl,
    dialogClassName,
    isHoverable,
  } = { ...defaultProps, ...filterUndefined(props) };
  const [open, setOpen] = useState(false);

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleOpenDialog = () => {
    setOpen(true);
  };

  return (
    <div className={`tooltip-with-indicator ${className}`}>
      {isHoverable ? (
        <HoverTooltip tabIndex={0} title={title} messages={messages} onClick={handleOpenDialog} />
      ) : (
        <CustomTooltip className='action-button-tooltip' title={title}>
          <HelpIcon tabIndex={0} onClick={handleOpenDialog} className='tooltip-with-indicator-icon' onKeyDown={(e) => { if (e.key === 'Enter') handleOpenDialog(); }} />
        </CustomTooltip>
      )}
      <Dialog
        open={open}
        transitionDuration={300}
        className={`tooltip-with-indicator-dialog ${dialogClassName}`}
      >
        {
          title
            ? (
              <DialogTitle>
                <div className='tooltip-with-indicator-title'>
                  <ErrorIcon className='tooltip-with-indicator-title-icon' />
                  {title}
                </div>
              </DialogTitle>
            ) : ''
        }
        <DialogContent className='tooltip-with-indicator-content'>
          {
            messages.map((m) => (
              <DialogContentText key={uuidv1()} className='tooltip-with-indicator-content-text'>
                {m}
              </DialogContentText>
            ))
          }
          {
            videoUrl ? (
              <CardMedia
                className='tooltip-video-player-inline-video'
                component='video'
                src={videoUrl}
                playsInline
                controls
              />
            ) : ''
          }
        </DialogContent>
        <DialogActions className='tooltip-with-indicator-actions'>
          <Button onClick={handleCloseDialog} color='primary' className='btn-primary tooltip-with-indicator-button'>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
